import { Flex } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import ActiveUsersCard from './activeUsersCard';
import BusinessByCategoryCard from './businessesByCategoryCard';
import useStats from './hooks/useStats';
import StatCard from './StatCard';
import SubscriptionBreakdownCard from './components/SubscriptionBreakdownCard';
import RecentBusinessesCard from './components/RecentBusinessesCard';
import QuickActionsCard from './components/QuickActionsCard';
import PlanDistributionCard from './components/PlanDistributionCard';
import DashboardFilters from './components/DashboardFilters';
import RecentUsersCard from './components/RecentUsersCard';
import TopEventsCard from './components/TopEventsCard';
import ActiveContractsCard from './components/ActiveContractsCard';

function Stats() {
  const navigate = useNavigate();
  const {
    stats,
    businessesByCategory,
    recentBusinesses,
    subscriptionBreakdown,
    planDistribution,
    totalUsers,
    totalEvents,
    totalInvites,
    payingBusinesses,
    trialBusinesses,
    expiredSubscriptions,
    filteredTotal,
    filters,
    setFilters,
    resetFilters,
    categories,
    recentUsers,
    topEvents,
    allBusinesses,
  } = useStats();
  const { t } = useTranslation();

  const hasFilters =
    filters.subscriptionType ||
    filters.dateFrom ||
    filters.dateTo ||
    filters.category;

  return (
    <Flex direction="column" pt={{ sm: '125px', lg: '75px' }} gap={4}>
      {/* Filters */}
      <DashboardFilters
        filters={filters}
        onChange={setFilters}
        onReset={resetFilters}
        categories={categories}
      />

      {/* Row 1: Key Metrics — each card navigates to the relevant table */}
      <Flex gap={2} wrap="wrap">
        <StatCard
          value={hasFilters ? filteredTotal : stats.totalBusinesses}
          label={
            hasFilters
              ? `${t('stats.total_businesses')} (filtered)`
              : t('stats.total_businesses')
          }
          bg="brand.500"
          flex="1"
          onClick={() => navigate('/admin/businesses/overview')}
        />
        <StatCard
          value={payingBusinesses}
          label={t('dashboard.paying_businesses')}
          bg="green.500"
          flex="1"
          onClick={() => navigate('/admin/businesses/overview')}
        />
        <StatCard
          value={trialBusinesses}
          label={t('dashboard.trial_businesses')}
          bg="blue.500"
          flex="1"
          onClick={() => navigate('/admin/businesses/overview')}
        />
        <StatCard
          value={expiredSubscriptions}
          label={t('dashboard.expired_subscriptions')}
          bg="red.400"
          flex="1"
          onClick={() => navigate('/admin/businesses/overview')}
        />
        <StatCard
          value={totalUsers}
          label={t('dashboard.total_users')}
          bg="purple.500"
          flex="1"
          onClick={() => navigate('/admin/brilliant_users/overview')}
        />
        <StatCard
          value={totalEvents}
          label={t('dashboard.total_events')}
          bg="orange.400"
          flex="1"
          onClick={() => navigate('/admin/events/overview')}
        />
        <StatCard
          value={totalInvites}
          label={t('dashboard.total_invites')}
          bg="teal.500"
          flex="1"
          onClick={() => navigate('/admin/invites/overview')}
        />
        <StatCard
          value={stats.invitedSuppliers}
          label={t('stats.invated_suppliers')}
          bg="brand.500"
          flex="1"
          onClick={() =>
            navigate('/admin/brilliant_users/users_with_suppliers')
          }
        />
      </Flex>

      {/* Row 2: Quick Actions */}
      <QuickActionsCard />

      {/* Row 3: Charts & Lists */}
      <Flex wrap="wrap" gap={4}>
        <SubscriptionBreakdownCard data={subscriptionBreakdown} />
        <PlanDistributionCard planStats={planDistribution} />
        <RecentBusinessesCard businesses={recentBusinesses} />
      </Flex>

      {/* Row 4: Analytics widgets (a–e) */}
      <Flex wrap="wrap" gap={4}>
        <RecentUsersCard users={recentUsers} />
        <TopEventsCard events={topEvents} />
        <ActiveContractsCard businesses={allBusinesses} />
      </Flex>

      {/* Row 5: Existing charts + daily logins */}
      <Flex wrap="wrap" gap={2}>
        <BusinessByCategoryCard businessesByCategory={businessesByCategory} />
        <ActiveUsersCard />
      </Flex>
    </Flex>
  );
}

export default Stats;
